


import { useState, useEffect, useRef, act } from "react";
import MKTypography from "components/MKTypography"; 
import Icon from "@mui/material/Icon";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Tooltip from "@mui/material/Tooltip";
import Checkbox from "@mui/material/Checkbox";
import Container from "@mui/material/Container";
//import Table from "components/Table";
import Slide from "@mui/material/Slide";
import Divider from "@mui/material/Divider";
import CloseIcon from "@mui/icons-material/Close";
import MKButton from "components/MKButton";
import MKBox from "components/MKBox";
import MKInput from "components/MKInput";
import Modal from "@mui/material/Modal";
import Dropdowns from "components/AppKey/Dropdowns";
import AppActionQR from "./AppActionQR";
import { appAuth } from "../../contexts/AppContext"
import localeList from "components/AppKey/locales.json"

export default function AppActionDetail({app, action, allGroups, onClose, onSubmit}) { 

    const renderRef = useRef(false) 
    const {getActionEmailTemplate, updateActionEmailTemplate, updateAppAction, updateAppActionCeremony} = appAuth()
    const [actionData, setActionData] = useState({ name:action.name, desc:action.desc, 
        appId:action.appId, actionId:action.actionId, 
        userId:action.userId, groupId:action.groupId,
        webhook:action.webhook, callbackUrl:action.callbackUrl,
        ceremony:action.ceremony,
        status:action.status,
        actionUrl:action.actionUrl,
        actionMessage:action.actionMessage,
        displayGroupId: action.displayGroupId || "None", 
        returnedTemplate:action.returnedTemplate || "",
        executed:action.executed, createdAt:action.createdAt, updatedAt:action.updatedAt
    })

    const [ceremony, setCeremony] = useState({
        Authentication: action.ceremony.Authentication ? true : false,
        Registration: action.ceremony.Registration ? true : false,
        Group: action.ceremony.Group  ? true : false,
    })

    const [isUpdated, isSetUpdated] = useState(false)
    const [isUpdatedEmail, isSetUpdatedEmail] = useState(false)
    const [showInfoModal, setShowInfoModal] = useState(false)
    const [showInfoCallbackModal, setShowInfoCallbackModal] = useState(false)
    const [showEditTemplate, setShowEditTemplate] = useState(false)
    const [showEditCallback, setShowEditCallback] = useState(false)
    const [emailTemplate, setEmailTemplate] = useState( { actionId: action.actionId, locale:"EN", replyTo: "", subject: "", htmlTemplate: "" })
    const [actionEmailTemplates, setActionEmailTemplates] = useState([]);
    const [appLocales, setAppLocales] = useState([])
    const [locale, setLocale] = useState("EN")

    useEffect(() => { 
        
        console.log("AppAction useEffect action ", action);
        
        if (renderRef.current === false){

            getActionData(action)
            
            return () => { 
                renderRef.current = true
                console.log("render clean up. ")
            }
        }

       

    }, [])

    useEffect(() => {
        console.log("updateAppActionCeremony ", ceremony)
        if(ceremony.Authentication != actionData.ceremony.Authentication ||
            ceremony.Registration != actionData.ceremony.Registration ||
            ceremony.Group != actionData.ceremony.Group
        ){
            console.log("updateAppActionCeremony ", ceremony)
            updateAppActionCeremony(actionData, ceremony)

            setActionData({
                ...actionData,
                ceremony: ceremony
            })

        }
    },[ceremony])

    const onChangeGroup = (val) => {
        setActionData({
            ...actionData,
            ['groupId']: val  
        }); 
       
        isSetUpdated(true)
        actionData.groupId = val
        updateAppAction(actionData);
    }

  

    const getActionData = async (item) => {
        console.log("AppAction getActionData item ", item);

        setActionData({
            ...actionData,
            ["displayGroupId"]: getGroupDisplayId(item.groupId)
        });

        let templates = await getActionEmailTemplate(item.actionId)
        if(templates) {
            setActionEmailTemplates(templates)
            let template = templates.filter(item => item.locale === locale) 
            console.log("email template template ", template)
            if (template && template[0]) setEmailTemplate(template[0]) 
            
        } 

        app.locales.map(locale => { 
            
            setAppLocales(prevItems => { 
                return [...prevItems, {text:`${locale} - ${findCountryByLocale(locale)}`, value:locale}];
            }); 
            
        }) 

    }

    const getGroupList = () => {
        let displayGroupIds = allGroups.map(item => `${item.groupId}` );
        displayGroupIds.unshift("None");
        return displayGroupIds
    }
     
    const getGroupDisplayId = (groupId) => { 
        if(!groupId) return "None";

        const filteredItems = allGroups.filter(item => { 
            return item.groupId === groupId;
        }); 
        let item = filteredItems[0];

        if(!item) return "None"; 
        let name = `${item.groupId} - ${item.name}`
        console.log("AppAction getGroupDisplayId name ", name);
        return name
    }
    
    
    const onChangeValue = (evt)=> {
        setActionData({
            ...actionData,
            [evt.target.name]: evt.target.value
        })

        isSetUpdated(true)
    } 

    const toggleInfoModal = () => {
        setShowInfoModal(!showInfoModal)
    }

    const toggleInfoCallbackModal = () => {
        setShowInfoCallbackModal(!showInfoCallbackModal)
    }

    const updateActionHandler = () => {

        onSubmit(actionData)
    }

    const handleCloseButton = () => {
        if(isUpdated || isUpdatedEmail) {
            if(window.confirm("You have unsaved changes. Are you sure to leave?")) {
                onClose()
            }
        } else  onClose(actionData)
        
    }

    function cancelUpdateEamil(e) {
        setShowEditTemplate(!showEditTemplate)  
        let template = actionEmailTemplates.filter(item => item.locale === locale) 
        setEmailTemplate(template[0] || { actionId:action.actionId, locale:locale, replyTo: "", subject: "", htmlTemplate: "" }) 

    }

    async function updateEamilActionHandler(){
        let result = await updateActionEmailTemplate(emailTemplate)
        if(result){
            isSetUpdatedEmail(false)

            let found = actionEmailTemplates.filter(item => item.locale === result.locale)[0]
            if(!found){
                setActionEmailTemplates(prevItems => { 
                    return [...prevItems, result];
                });  
            }
            else {
                setActionEmailTemplates(actionData.map(item => { 
                    if (item.locale === result.locale){ 
                        return result 
                    } 
                    else return item
                })); 
            }
        }
    }



    
    function handleFieldValueChange(e) {
        setEmailTemplate({
            ...emailTemplate,
            [e.target.name]: e.target.value,
        });

        // setActionData({
        //     ...actionData,
        //     ['emailTemplate']: {
        //         ...actionData.emailTemplate,
        //         [e.target.name]: e.target.value,
        //     }
        // })

        isSetUpdatedEmail(true)

    }

    const findCountryByLocale = (code) =>{
            let country = localeList.list.filter(item => item.code == code)[0];
            if (code === "EN") return" English (default)";
            return country ? country.name : "";
        }

    
    const handleSelectLocalEmailTemplate = (evt) => {
        
        console.log("handleSelectLocalEmailTemplate ", evt.target.value)
        let value = evt.target.value

        setLocale(value) 

        let template = actionEmailTemplates.filter(item => item.locale === value) 
        if (template && template[0]) setEmailTemplate(template[0]) 
        else setEmailTemplate({ actionId:action.actionId, locale:value, replyTo: "", subject: "", htmlTemplate: "" }) 
    }; 

    

    const onCheckedCeremony = async(event) => { 
        
        setCeremony( { 
            ...ceremony,  
            [event.target.name] : event.target.checked
        });  

         
    }

      

    return(
        <MKBox>
           <MKBox display="flex" justifyContent="space-between"> 

                <Tooltip title="go back" placement="top">
                    <MKButton variant="outlined" color="info" onClick={() =>  handleCloseButton() }  p={2} iconOnly> <Icon sx={{ mr: 1 }}>arrow_back</Icon> </MKButton>
                </Tooltip>
                <MKTypography variant="h4" >
                    Update Application Action: {action.name}
                </MKTypography> 

                <MKButton variant="gradient" color="primary" onClick={updateActionHandler} > Save </MKButton> 

            </MKBox>

            <Container>

                <Grid container spacing={3} mt={2}  pb={5}>
                    <Grid item xs={12} md={5} lg={5}>
                        <Stack spacing={3}>

                            <MKBox component="section" display="flex">  
                                <MKInput variant="standard" label="Action ID" disabled value={action.actionId}  /> 
                                
                                <MKButton color="white" onClick={() => {navigator.clipboard.writeText(action.actionId)}}>
                                    <Icon fontSize="large">copy</Icon>
                                </MKButton>
                                
                            </MKBox>
                            
                            <MKInput variant="standard" inputProps={{ maxLength: 50 }} label="Action Name" id="name" name='name' defaultValue={action.name} onChange={onChangeValue} required fullWidth  />

                             <MKInput variant="standard" inputProps={{ maxLength: 250 }} label="Action Description" id="description" name='desc' defaultValue={action.desc} onChange={onChangeValue} multiline rows={4} fullWidth  />
                          

                            <MKBox alignItems="center" justifyContent="left" >
                                
                                <MKTypography variant="h6" color="text">
                                Ceremonies
                                </MKTypography>
                                <MKBox alignItems="center"  display="flex" justifyContent="space-between">
                                    <MKBox display="flex" alignItems="center" ml={-1}>
                                        <Checkbox name='Registration' checked={ceremony.Registration}  onChange={onCheckedCeremony} />
                                        <MKTypography
                                            variant="button"
                                            fontWeight="regular"
                                            color="text"
                                            sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                                        >
                                        &nbsp;&nbsp;Registration
                                        </MKTypography>
                                    </MKBox>

                                    <MKBox display="flex" alignItems="center" ml={-1}>
                                        <Checkbox  name='Authentication' checked={ceremony.Authentication}  onChange={onCheckedCeremony}/>
                                        <MKTypography
                                            variant="button"
                                            fontWeight="regular"
                                            color="text"
                                            sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                                        >
                                        &nbsp;&nbsp;Authentication
                                        </MKTypography>
                                    </MKBox>
                                    
                                    <MKBox display="flex" alignItems="center" ml={-1}>
                                        <Checkbox  name='Group' checked={ceremony.Group}  onChange={onCheckedCeremony}/>
                                        <MKTypography
                                            variant="button"
                                            fontWeight="regular"
                                            color="text"
                                            sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                                        >
                                        &nbsp;&nbsp;Group
                                        </MKTypography>
                                    </MKBox>
                                    
                                    
                                    {/* <Dropdowns items={["Registration",  "Authentication", "Both", "Group"]} defaultValue = { actionData.ceremony } onChange={(value) => { 
                                           onChangeCeremony(value);
                                        }} /> */}

                                </MKBox> 
                            </MKBox>
                            {actionData.ceremony.Group &&  
                            <MKBox>
                                <MKBox alignItems="center" justifyContent="left" display="flex" >
                                    <MKTypography variant="h6" color="text">
                                    Group
                                    </MKTypography>

                                    <Dropdowns items={getGroupList()} defaultValue = { actionData.groupId || "None" } onChange={(val) => { 
                                        onChangeGroup(val); 
                                     
                                    }} />

                                </MKBox>

                                
                            </MKBox>

                            }

                            <MKBox alignItems="center" justifyContent="left"  >
                                <MKTypography variant="h6" color="text">Action URL</MKTypography>
                                
                                <MKBox mb={2}>
                                    <MKInput
                                        variant="standard"
                                        label="Action URL"
                                        placeholder="eg: https://yourdomain.com/yourapp/action" 
                                        name='actionUrl' defaultValue={actionData.actionUrl} onChange={onChangeValue}
                                        fullWidth
                                    />
                                     
                                </MKBox>  

                            </MKBox>

                            <MKBox alignItems="center" justifyContent="left"  >
                                <MKBox display="flex" justifyContent="space-between"> 
                                    <Stack direction="row" alignItems="center">
                                        <MKTypography variant="h5" color="dark">Action Message</MKTypography>
                                        
                                    </Stack>

                                    <MKButton color="white" onClick={toggleInfoCallbackModal} >
                                        <Icon fontSize="large">help</Icon>
                                    </MKButton>
                                </MKBox>  
                                
                                <MKBox mb={2}> 

                                     <MKInput name="actionMessage"  
                                                defaultValue={actionData.actionMessage} 
                                                fullWidth id = "actionMessage" 
                                                multiline  rows={3} 
                                                placeholder="eg: Thank you for using %APP_NAME%. Your action %ACTION_NAME% is successful." 
                                                onChange={onChangeValue}/> 
                                     
                                </MKBox>  

                            </MKBox>

                            
                        
                        </Stack>
                    </Grid>


                    <Grid item xs={12} md={2} lg={2}></Grid>
                    
                    

                    <Grid item xs={12} md={5} lg={5} >
                        <MKBox>
                            <MKBox alignItems="center" justifyContent="left"  >
                                <MKTypography variant="h6" color="text">Webhook URL</MKTypography>
                                <MKTypography variant="caption" color="info">AppKey will call an HTTPS POST request to this endpoint</MKTypography>
                                <MKBox mb={2}>
                                    <MKInput
                                        variant="standard"
                                        label="Webhook URL"
                                        placeholder="eg: https://yourserverapi.com/webhook" 
                                        name='webhook' defaultValue={actionData.webhook} onChange={onChangeValue}
                                        fullWidth
                                    />
                                     
                                </MKBox>  

                            </MKBox>

                            <MKBox alignItems="center" justifyContent="left"  >
                                <MKBox display="flex" justifyContent="space-between"> 
                                    <Stack direction="row" alignItems="center">
                                        <MKTypography variant="h5" color="dark">Returned Message</MKTypography>
                                        
                                    </Stack>

                                    <MKButton color="white" onClick={toggleInfoCallbackModal} >
                                        <Icon fontSize="large">help</Icon>
                                    </MKButton>
                                </MKBox> 

                                <MKTypography variant="caption" color="info">AppKey will include this message in scan result</MKTypography>
                                <MKBox mb={2}> 

                                     <MKInput name="returnedTemplate"  
                                                defaultValue={actionData.returnedTemplate} 
                                                fullWidth id = "returnedTemplate" 
                                                multiline  rows={3} 
                                                placeholder="eg: Thank you for using %APP_NAME%. Your action %ACTION_NAME% is successful." 
                                                onChange={onChangeValue}/> 
                                     
                                </MKBox>  

                            </MKBox>

                            <MKBox alignItems="center" justifyContent="left"  >
                                <MKBox display="flex" justifyContent="space-between"> 
                                    <Stack direction="row" alignItems="center">
                                        <MKTypography variant="h5" color="dark">Returned URL</MKTypography>
                                        
                                    </Stack>

                                    <MKButton color="white" onClick={toggleInfoCallbackModal} >
                                        <Icon fontSize="large">help</Icon>
                                    </MKButton>
                                </MKBox> 

                                <MKTypography variant="caption" color="info">AppKey will include this url in scan result</MKTypography>
                                <MKBox mb={2}>
                                    

                                     <MKInput name="callbackUrl" 
                                     
                                                defaultValue={actionData.callbackUrl} 
                                                fullWidth id = "callbackUrl" 
                                                multiline  rows={3} 
                                                placeholder="eg: https://yourwebsite.com/%ACTION_ID%" 
                                                onChange={onChangeValue}/> 
                                     
                                </MKBox>  

                            </MKBox>

                            

                            <MKBox alignItems="center" justifyContent="left"  >
                                
                                <MKBox display="flex" justifyContent="space-between"> 
                                    <Stack direction="row" alignItems="center">
                                        <MKTypography variant="h5" color="dark">Email Template</MKTypography>
                                        <MKButton variant="text" color="info"size="large" onClick={() => setShowEditTemplate(!showEditTemplate)} >
                                            <Icon >edit</Icon>
                                        </MKButton>
                                    </Stack>

                                    <MKButton color="white" onClick={toggleInfoModal} >
                                        <Icon fontSize="large">help</Icon>
                                    </MKButton>
                                </MKBox>  
                                <MKTypography variant="caption" color="info">AppKey will use this template to send email after scanning</MKTypography>

                                {showEditTemplate ?

                                <Stack spacing={5}>
                                    
                                    <Stack direction="row" alignItems="center"  py={2}>
                                                    
                                    
                                        <FormControl variant="standard" sx={{ m: 1, minWidth: 180 }}>
                                            
                                            <Select
                                                labelId="simple-select-standard-label"
                                                id="simple-select-standard" 
                                                 onChange={handleSelectLocalEmailTemplate}
                                                defaultValue="EN"
                                            >
                                                {
                                                    appLocales.map(function(item, index){ 
                                                        return(
                                                            <MenuItem value={item.value}  key={index}>{item.text}</MenuItem> 
                                                        )
                                                    })
                                                }
                        
                        
                                            </Select>
                                        </FormControl>
                        
                                        
                                       
                                    </Stack>
                                    
                                    <MKInput type="email" name="replyTo" label="Reply To Email" value={emailTemplate.replyTo } fullWidth id = "replyToInput"  placeholder="noreply@appkey.com"
                                    inputProps={{ autoComplete: "off", autoCapitalize: "none", style: { textTransform: "lowercase" } }}
                                    onChange={handleFieldValueChange}/>
                                    
                                    <MKInput label="Subject" name="subject" value={emailTemplate.subject } fullWidth id = "subjectInput" placeholder="Subject of the email" onChange={handleFieldValueChange}/>
                                    
                                    <MKInput name="htmlTemplate" value={emailTemplate.htmlTemplate} fullWidth id = "messageInput"  multiline  rows={8} placeholder="hmtl code" onChange={handleFieldValueChange}/>
                                    
                                    <Stack direction="row" spacing={5} mt={3}>
                                        <MKButton variant="outlined" color="info" onClick={cancelUpdateEamil}>Cancel</MKButton>
                                        <MKButton variant="gradient" color="primary" onClick={updateEamilActionHandler}>Save</MKButton>
                                    </Stack>
                                </Stack>
                                
                                     :
                                    <MKBox>
                                        <div dangerouslySetInnerHTML= {
                                            { __html: actionEmailTemplates.length === 0 ? "<i>No email template</i>" : actionEmailTemplates[0].htmlTemplate}
                                        } />
                                    </MKBox>
                                   
                                }

                            </MKBox>


                        </MKBox>
                    </Grid>
                </Grid>

                <AppActionQR app={app} action={action} />
           

                
            </Container>



            <Modal open={showInfoModal} onClose={toggleInfoModal} sx={{ display: "grid", placeItems: "center" }}>
                <Slide direction="down" in={showInfoModal} timeout={200}>
                <MKBox
                    position="relative"
                    sx={{ maxWidth: 'md' }}
                    display="flex"
                    flexDirection="column"
                    borderRadius="xl"
                    bgColor="white"
                    shadow="xl"
                >
                    <MKBox display="flex" alignItems="center" justifyContent="space-between" p={2}>
                        <MKTypography variant="h5">Customize account management emails</MKTypography> 
                        <CloseIcon fontSize="medium" sx={{ cursor: "pointer" }} onClick={toggleInfoModal} />
                    </MKBox>
                    <Divider sx={{ my: 0 }} />

                    <MKBox p={2}>
                        <MKTypography variant="body">When you customize an handle template's subject line and message, you can use the following placeholder strings to represent values that will be filled in before sending:</MKTypography>
                    </MKBox>
                
                    <MKBox p={1.5}> 
                        <p>
                            <b>%APP_NAME%</b>	The name of your app. You can set this value by editing the App name field on the App page.<br/> 
                            <b>%APP_ID%</b>	Application ID.<br/> 
                            
                            <b>%HANDLE%</b>	The recipient's handle address or phone number.<br/> 
                            <b>%FULL_NAME%</b> The full name of the user. This is set by user on signup. <br/> 
                            <b>%GROUP_NAME%</b> Group name. <br/>
                            <b>%GROUP_ID%</b>	Group ID.<br/>  
                            <b>%ACTION_NAME%</b>	Action name.<br/> 
                            <b>%ACTION_DESCRIPTION%</b>	Action description.<br/> 
                            <b>%ACTION_ID%</b>	Action ID.<br/> 
                            <b>%DEVICE%</b>	Device.<br/> 
                            <b>%CEREMONY%</b> Action ceremony.<br/>  
                        </p>
                    </MKBox>
                    <Divider sx={{ my: 0 }} />
                    <MKBox display="flex" justifyContent="center" p={1.5}>
                        <MKButton variant="gradient" color="dark" onClick={toggleInfoModal}>
                            Close
                        </MKButton>
                
                    </MKBox>
                </MKBox>
                </Slide>
            </Modal>
             
            

            <Modal open={showInfoCallbackModal} onClose={toggleInfoCallbackModal} sx={{ display: "grid", placeItems: "center" }}>
                <Slide direction="down" in={showInfoCallbackModal} timeout={200}>
                <MKBox
                    position="relative"
                    sx={{ maxWidth: 'md' }}
                    display="flex"
                    flexDirection="column"
                    borderRadius="xl"
                    bgColor="white"
                    shadow="xl"
                >
                    <MKBox display="flex" alignItems="center" justifyContent="space-between" p={2}>
                        <MKTypography variant="h5">Customize returned template</MKTypography> 
                        <CloseIcon fontSize="medium" sx={{ cursor: "pointer" }} onClick={toggleInfoCallbackModal} />
                    </MKBox>
                    <Divider sx={{ my: 0 }} />

                    <MKBox p={2}>
                        <MKTypography variant="body">When you customize a returned template, you can use the following placeholder strings to represent values that will be filled in before sending:</MKTypography>
                    </MKBox>
                
                    <MKBox p={1.5}> 
                        <p>
                            <b>%APP_NAME%</b>	The name of your app. You can set this value by editing the App name field on the App page.<br/> 
                            <b>%APP_ID%</b>	Application ID.<br/> 
                            
                            <b>%HANDLE%</b>	The recipient's handle address or phone number.<br/> 
                            <b>%FULL_NAME%</b> The full name of the user. This is set by user on signup. <br/> 
                            <b>%GROUP_NAME%</b> Group name. <br/>
                            <b>%GROUP_ID%</b>	Group ID.<br/>  
                            <b>%ACTION_NAME%</b>	Action name.<br/> 
                            <b>%ACTION_DESCRIPTION%</b>	Action description.<br/> 
                            <b>%ACTION_ID%</b>	Action ID.<br/> 
                            <b>%DEVICE%</b>	Device.<br/> 
                            <b>%CEREMONY%</b> Action ceremony.<br/>  
                        </p>
                    </MKBox>
                    <Divider sx={{ my: 0 }} />
                    <MKBox display="flex" justifyContent="center" p={1.5}>
                        <MKButton variant="gradient" color="dark" onClick={toggleInfoCallbackModal}>
                            Close
                        </MKButton>
                
                    </MKBox>
                </MKBox>
                </Slide>
            </Modal>
             
            
       

        </MKBox>

        

    )
        
}